import React from 'react';

class Loading extends React.Component {
  render() {
    return (
      <div className="fm-loading">
        <div className="fm-loading-spinner"></div>
      </div>
    );
  }
}

export default Loading;
